import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Tooltip from '../UI/Tooltip';
import { redirectToStripe } from './PricePlanesAcademic';
import './pricingtable.css';
import CommonHeader from '../Headers/CommonHeader';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import Login from '../../modules/login/Login';
import { userAppContext } from '../../Context/Context';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'transparent',
    border: 'none',
  },
};

function PricingTablesAcademic() {
  const navigate = useNavigate();
  const { isAuthenticated } = userAppContext();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingPlan, setPendingPlan] = useState(null);

  const handleUpgradeClick = (planName, priceId) => {
    if (!isAuthenticated) {
      setPendingPlan({ planName, priceId });
      setShowLoginModal(true);
    } else {
      redirectToStripe(planName, priceId);
    }
  };

  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    setPendingPlan(null);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Academic Plans</title>
        <meta name="description" content="Explore DISGENET academic pricing plans." />
      </Helmet>
      <CommonHeader />
      <div>
        <table
          className="table panther-table table-edit sticky"
          style={{ margin: '10px auto 10px', width: '70%', textAlign: 'center' }}
        >
          <thead>
            <tr className="table-titles">
              <th></th>
              <th>STANDARD</th>
              <th>ADVANCED</th>
            </tr>
          </thead>

          <tbody>
            {isAuthenticated && (
              <tr>
                <td>
                  <span className="table-subsubtitles "></span>
                </td>
                <td className="grid">
                  <div>
                    <span className="font-bold text-2xl">99.92</span>
                    <small>€/mo</small>
                  </div>
                  <span>
                    <small>(1,199€ billed yearly)</small>
                  </span>
                </td>
                <td>
                  <div>
                    <span className="font-bold text-2xl">166.58</span>
                    <small>€/mo</small>
                  </div>
                  <span>
                    <small>(1,999€ billed yearly)</small>
                  </span>
                </td>
              </tr>
            )}
            <tr>
              <td>
                <span className="table-subsubtitles">Full database access</span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">Web platform</span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">REST-API </span>
              </td>
              <td>
                <i className="bi bi-x-circle-fill x-circle"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                {' '}
                <a href="https://gitlab.com/medbio/disgenet2r" target="_blank" rel="noopener noreferrer">
                  <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
                    R package
                  </u>
                </a>
              </td>
              <td>
                <i className="bi bi-x-circle-fill x-circle"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                {' '}
                <a
                  href="https://apps.cytoscape.org/apps/disgenetapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
                    Cytoscape App
                  </u>
                </a>
              </td>
              <td>
                <i className="bi bi-x-circle-fill x-circle"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">
                  AI Assistant{' '}
                  <Tooltip content="Ask questions about the data in plain text—no coding needed">
                    <i className="bi bi-info-circle"></i>
                  </Tooltip>
                </span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles ">
                  Advanced Search{' '}
                  <Tooltip content="Bulk query up to 100 genes, diseases, variants, or chemicals on the web">
                    <i className="bi bi-info-circle"></i>
                  </Tooltip>
                </span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
          </tbody>
          {process.env.REACT_APP_ENABLE_STRIPE_PAYMENTS === 'true' && (
            <tfoot>
              <tr>
                <td></td>
                <td>
                  <button
                    onClick={() =>
                      handleUpgradeClick(
                        'Standard',
                        process.env.REACT_APP_STRIPE_STANDARD_PRICE_ID || 'price_1SCebx2Ml6stFA0rHcXCPwNj',
                      )
                    }
                    className="btn-gradient-pink"
                  >
                    Get Standard
                  </button>
                </td>
                <td>
                  <button
                    onClick={() =>
                      handleUpgradeClick(
                        'Advanced',
                        process.env.REACT_APP_STRIPE_ADVANCED_PRICE_ID || 'price_1SPPcK2Ml6stFA0rOiXzsUUM',
                      )
                    }
                    className="btn-gradient-pink"
                  >
                    Get Advanced
                  </button>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
        {process.env.REACT_APP_ENABLE_STRIPE_PAYMENTS === 'false' && (
          <div className="text-center">
            <button onClick={() => navigate('/Support')} className="btn-gradient-pink">
              Contact us
            </button>
          </div>
        )}
      </div>

      <Modal
        isOpen={showLoginModal}
        onRequestClose={() => setShowLoginModal(false)}
        ariaHideApp={false}
        style={customStyles}
        shouldFocusAfterRender={false}
      >
        <Login onLoginSuccess={handleLoginSuccess} onClose={() => setShowLoginModal(false)} />
      </Modal>
    </React.Fragment>
  );
}

export default PricingTablesAcademic;
